<template>
  <div>
    <div class="cui__utils__heading">
      <strong>Today Statistics</strong>
    </div>
    <div class="row" v-if="statistics">
      <div class="col-xl-4">
        <div class="card">
          <widget-counter name="Customers" :count="statistics['crm.customers']" />
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <widget-counter name="Projects" :count="statistics['pm.projects']" />
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <widget-counter name="Staffs" :count="statistics['system.staffs']" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <router-link class="card btn box" to="/crm/quick-search">
          <span>进入快查模式</span>
        </router-link>
      </div>
      <div class="col-xl-4">
        <router-link class="card btn box" to="/crm/customers">
          <span>进入客户列表</span>
        </router-link>
      </div>
      <div class="col-xl-4">
        <router-link class="card btn box" to="/pm/projects">
          <span>进入项目列表</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// new
import { WidgetCounter } from '@/components/reno/widgets/'

export default {
  components: {
    WidgetCounter,
  },

  computed: {
    statistics() {
      return this.$store.getters['admin/statistics']
    },
  },
}
</script>

<style lang="scss">
.box {
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    padding: 2rem;
    font-size: 2rem;
  }
}
</style>
